import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export default function ListButton({ navItem, handleClick, isExpanded }) {
	return (
		<ListItem button onClick={handleClick}>
			<Tooltip title={navItem.label}>
				<ListItemIcon>
					<navItem.iconComponent />
				</ListItemIcon>
			</Tooltip>
			<ListItemText primary={navItem.label} />
			{navItem.hasSubItems && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
		</ListItem>
	);
}

ListButton.defaultProps = {
	hasSubItems: false,
	isExpanded: true
};
